import type { ReactNode } from 'react';

// The interface's icons, drawn on a 24 px grid with one light stroke, as FLBI's (Phosphor light).
const PATHS = {
    search: 'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM15.2 15.2 20 20',
    clock: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zM12 7.5V12l3 2',
    chevron: 'M7 10l5 5 5-5',
    star: 'M12 3.8l2.6 5.4 5.9.7-4.4 4.1 1.2 5.9-5.3-2.9-5.3 2.9 1.2-5.9-4.4-4.1 5.9-.7z',
    link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
    bell: 'M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0',
    x: 'M6.5 6.5l11 11M17.5 6.5l-11 11',
    up: 'M12 19V5M6 11l6-6 6 6',
    down: 'M12 5v14M6 13l6 6 6-6',
    eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 14.8a2.8 2.8 0 1 0 0-5.6 2.8 2.8 0 0 0 0 5.6z',
    shield: 'M12 3.5l7 2.8v5.4c0 4.3-3 7.6-7 8.8-4-1.2-7-4.5-7-8.8V6.3zM9 12l2 2 4-4',
    plus: 'M12 5v14M5 12h14',
    minus: 'M5 12h14',
    copy: 'M11.5 9h7A2.5 2.5 0 0 1 21 11.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 9 18.5v-7A2.5 2.5 0 0 1 11.5 9zM5 15V5.5A2.5 2.5 0 0 1 7.5 3H15',
    external: 'M14 5h5v5M19 5l-8 8M18 14v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4',
    user: 'M12 12a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 19.5c1.2-3.3 3.8-5 7-5s5.8 1.7 7 5',
    bolt: 'M13 3L5 13.5h6L10 21l8-10.5h-6z',
    lines: 'M4 7h16M4 12h10M4 17h7',
    refresh: 'M19.5 12a7.5 7.5 0 1 1-2.2-5.3M19.5 4.5v4h-4',
    arrow: 'M5 12h14M13 6l6 6-6 6',
    back: 'M19 12H5M11 6l-6 6 6 6',
    check: 'M5 12.5l4.5 4.5L19 7.5',
    dots: 'M6 12h.01M12 12h.01M18 12h.01',
    zoomout: 'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM15.2 15.2 20 20M7.5 10.5h6',
    help: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17zM9.6 9.4a2.5 2.5 0 1 1 3.4 2.3c-.7.3-1 .8-1 1.5v.3M12 16.6h.01',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon(props: { name: IconName; size?: number; className?: string }): ReactNode {
    const size = props.size ?? 16;

    return (
        <svg
            className={props.className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={props.name === 'dots' ? 2.6 : 1.6}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
        >
            <path d={PATHS[props.name]} />
        </svg>
    );
}
